import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { PopupProvider } from 'react-popup-manager';
import Routes from 'routes';
// import './styles/crema.less';
import Loading from 'components/molecules/Loading';
import Authority from 'components/authority';
import DefaultLayout from 'components/organisms/DefaultLayout';
import 'antd/dist/antd.css';
import './styles/common.scss';

function App() {
  return (
    <PopupProvider>
      <Suspense fallback={<Loading size="large" />}>
        <DefaultLayout>
          <Authority>{useRoutes(Routes.paths)}</Authority>
        </DefaultLayout>
      </Suspense>
    </PopupProvider>
  );
}

export default App;
